 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CreateNFTForm~NFTsRead~ViewNFTForm~accountsRead~calendarCreate~partnerDetail~partnersRead~profileRea~87ef4a50":"CreateNFTForm~NFTsRead~ViewNFTForm~accountsRead~calendarCreate~partnerDetail~partnersRead~profileRea~87ef4a50","CreateNFTForm~NFTsRead~ViewNFTForm~sellNFTForm":"CreateNFTForm~NFTsRead~ViewNFTForm~sellNFTForm","CreateNFTForm":"CreateNFTForm","NFTsRead":"NFTsRead","ViewNFTForm":"ViewNFTForm","sellNFTForm":"sellNFTForm","accountsRead":"accountsRead","calendarCreate~projectsCreate~public~shopCreate":"calendarCreate~projectsCreate~public~shopCreate","calendarCreate":"calendarCreate","projectsCreate":"projectsCreate","public":"public","shopCreate":"shopCreate","partnerDetail":"partnerDetail","partnersRead":"partnersRead","profileRead":"profileRead","projectsRead":"projectsRead","shopRead":"shopRead","NFTs":"NFTs","accounts":"accounts","auth":"auth","auth.Recover":"auth.Recover","auth.RecoverHash":"auth.RecoverHash","auth.onboarding":"auth.onboarding","auth.signin":"auth.signin","auth.signup":"auth.signup","calendar":"calendar","calendarRead":"calendarRead","consultant":"consultant","consultantRead":"consultantRead","data":"data","dataRead":"dataRead","error":"error","improve":"improve","organization":"organization","organizationRead":"organizationRead","partners":"partners","profile":"profile","projects":"projects","readImprove":"readImprove","shop":"shop","tip1":"tip1","tip2":"tip2","tip3":"tip3","tip4":"tip4","tip5":"tip5","tip6":"tip6","tip7":"tip7","tip8":"tip8","user":"user","user.home":"user.home","web":"web"}[chunkId]||chunkId) + "." + {"CreateNFTForm~NFTsRead~ViewNFTForm~accountsRead~calendarCreate~partnerDetail~partnersRead~profileRea~87ef4a50":"0041db5b","CreateNFTForm~NFTsRead~ViewNFTForm~sellNFTForm":"796e1886","CreateNFTForm":"48655d69","NFTsRead":"8586a6fb","ViewNFTForm":"209fd746","sellNFTForm":"397c2ae8","accountsRead":"b715dfef","calendarCreate~projectsCreate~public~shopCreate":"29c25b01","calendarCreate":"027ceda5","projectsCreate":"b6bf09f5","public":"2adfef92","shopCreate":"ac9dbb54","partnerDetail":"cb4c0322","partnersRead":"9871c508","profileRead":"c1fa7c3d","projectsRead":"7b1534f3","shopRead":"14ad6a66","NFTs":"5392c9f9","accounts":"519c0408","auth":"c50a4cbc","auth.Recover":"9e68521f","auth.RecoverHash":"8923acc4","auth.onboarding":"b5b7994f","auth.signin":"df7c392e","auth.signup":"88b720df","calendar":"d4e667a6","calendarRead":"89813331","consultant":"913b6352","consultantRead":"ce74111e","data":"f781cf7f","dataRead":"7cfb9086","error":"bea4f32f","improve":"4108a385","organization":"2744efb6","organizationRead":"33aa17ac","partners":"0b2ac92c","profile":"e7917ac8","projects":"0e952461","readImprove":"5ad8da16","shop":"d400d999","tip1":"de27d200","tip2":"e00ee585","tip3":"bacb1613","tip4":"9309f23c","tip5":"c03ebe6c","tip6":"a6be2301","tip7":"c61f20cf","tip8":"a2653392","user":"7d7360f6","user.home":"adf88254","web":"954834f0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CreateNFTForm~NFTsRead~ViewNFTForm~accountsRead~calendarCreate~partnerDetail~partnersRead~profileRea~87ef4a50":1,"CreateNFTForm~NFTsRead~ViewNFTForm~sellNFTForm":1,"CreateNFTForm":1,"NFTsRead":1,"ViewNFTForm":1,"sellNFTForm":1,"accountsRead":1,"calendarCreate~projectsCreate~public~shopCreate":1,"calendarCreate":1,"projectsCreate":1,"public":1,"shopCreate":1,"partnerDetail":1,"partnersRead":1,"profileRead":1,"projectsRead":1,"shopRead":1,"NFTs":1,"accounts":1,"auth":1,"auth.Recover":1,"auth.RecoverHash":1,"auth.onboarding":1,"auth.signin":1,"auth.signup":1,"calendar":1,"calendarRead":1,"consultant":1,"consultantRead":1,"data":1,"dataRead":1,"improve":1,"organization":1,"organizationRead":1,"partners":1,"profile":1,"projects":1,"readImprove":1,"shop":1,"tip1":1,"tip2":1,"tip3":1,"tip4":1,"tip5":1,"tip6":1,"tip7":1,"tip8":1,"user":1,"user.home":1,"web":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CreateNFTForm~NFTsRead~ViewNFTForm~accountsRead~calendarCreate~partnerDetail~partnersRead~profileRea~87ef4a50":"CreateNFTForm~NFTsRead~ViewNFTForm~accountsRead~calendarCreate~partnerDetail~partnersRead~profileRea~87ef4a50","CreateNFTForm~NFTsRead~ViewNFTForm~sellNFTForm":"CreateNFTForm~NFTsRead~ViewNFTForm~sellNFTForm","CreateNFTForm":"CreateNFTForm","NFTsRead":"NFTsRead","ViewNFTForm":"ViewNFTForm","sellNFTForm":"sellNFTForm","accountsRead":"accountsRead","calendarCreate~projectsCreate~public~shopCreate":"calendarCreate~projectsCreate~public~shopCreate","calendarCreate":"calendarCreate","projectsCreate":"projectsCreate","public":"public","shopCreate":"shopCreate","partnerDetail":"partnerDetail","partnersRead":"partnersRead","profileRead":"profileRead","projectsRead":"projectsRead","shopRead":"shopRead","NFTs":"NFTs","accounts":"accounts","auth":"auth","auth.Recover":"auth.Recover","auth.RecoverHash":"auth.RecoverHash","auth.onboarding":"auth.onboarding","auth.signin":"auth.signin","auth.signup":"auth.signup","calendar":"calendar","calendarRead":"calendarRead","consultant":"consultant","consultantRead":"consultantRead","data":"data","dataRead":"dataRead","error":"error","improve":"improve","organization":"organization","organizationRead":"organizationRead","partners":"partners","profile":"profile","projects":"projects","readImprove":"readImprove","shop":"shop","tip1":"tip1","tip2":"tip2","tip3":"tip3","tip4":"tip4","tip5":"tip5","tip6":"tip6","tip7":"tip7","tip8":"tip8","user":"user","user.home":"user.home","web":"web"}[chunkId]||chunkId) + "." + {"CreateNFTForm~NFTsRead~ViewNFTForm~accountsRead~calendarCreate~partnerDetail~partnersRead~profileRea~87ef4a50":"7671518d","CreateNFTForm~NFTsRead~ViewNFTForm~sellNFTForm":"fd5127dc","CreateNFTForm":"5e0e6795","NFTsRead":"6bd6a62b","ViewNFTForm":"f7988c29","sellNFTForm":"ba591b6d","accountsRead":"7716700a","calendarCreate~projectsCreate~public~shopCreate":"36edaef9","calendarCreate":"8d9c5cd0","projectsCreate":"b58c87cb","public":"ab3c8916","shopCreate":"0d133eea","partnerDetail":"b0da257d","partnersRead":"c76cbb9f","profileRead":"b67082d7","projectsRead":"41a067e0","shopRead":"99f7ee56","NFTs":"4d67c652","accounts":"723709a2","auth":"00037da9","auth.Recover":"043dbfe9","auth.RecoverHash":"23950b24","auth.onboarding":"6317ca27","auth.signin":"5fa2297a","auth.signup":"2f2c9f10","calendar":"ddfdbeda","calendarRead":"4b04134e","consultant":"59518a0e","consultantRead":"aef4c488","data":"8041c6a4","dataRead":"08c975c7","error":"31d6cfe0","improve":"4771b4a9","organization":"b0be0047","organizationRead":"91494093","partners":"6f6e7ed6","profile":"b6f9aa17","projects":"a8317597","readImprove":"4fe945c8","shop":"6bad4d84","tip1":"56c13850","tip2":"8f90c10c","tip3":"f4fdf6a2","tip4":"4b6e14f6","tip5":"76ae75a2","tip6":"d8755e63","tip7":"636021c2","tip8":"4c60f7b0","user":"332d4d56","user.home":"d500eb9d","web":"3c49c1a9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
